import { render, staticRenderFns } from "./LicenseKind.vue?vue&type=template&id=5917f29a&scoped=true"
import script from "./LicenseKind.vue?vue&type=script&lang=js"
export * from "./LicenseKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5917f29a",
  null
  
)

export default component.exports